import _ from 'lodash';

//************************************************************//
//                 FINDING ITEMS IN THE TREE                  //
//************************************************************//
const findCurrentEditingRow = (devis) => {
    var mapped = mapPrefixes(devis);
    var flattened = flatten(mapped);
    return _.find(flattened, x => x.editing)
}

const getLastRow = (devis) => {
    var mapped = mapPrefixes(devis);
    var flattened = flatten(mapped);
    if(flattened.length == 0 ) {
        return undefined;
    }
    return flattened[flattened.length - 1];
}

const hasCategory = (devis) => {
    var mapped = mapPrefixes(devis);
    var flattened = flatten(mapped);
    return _.findIndex(flattened, x => x.type === 'category') > -1;
}

const getLastCategory = (devis) => {
    var mapped = mapPrefixes(devis);
    var flattened = flatten(mapped);
    return _.findLast(flattened, x => x.type === 'category');
}

/**
 * Select next row (= direct lower child in the flattened tree)
 * @param {array} devis Devis Tree 
 */
const selectNext = (devis) => {
    var mapped = mapPrefixes(devis);
    var flattened = flatten(mapped);
    var row = _.findIndex(flattened, x => x.editing)
    if(row < 0){ // Currently no editable row
        return devis;
    }
    if(flattened[row + 1]) {
        var nextRow = flattened[row + 1];
        return editTree(editAllRow(devis, {editing: false}), nextRow, {editing : true} );
    }
    return mapped;
}


/**
 * Select previous row (= direct upper child in the flattened tree)
 * @param {array} devis Devis Tree 
 */
const selectPrevious = (devis) => {
    var mapped = mapPrefixes(devis);
    var flattened = flatten(mapped);
    var row = _.findIndex(flattened, x => x.editing)
    if(row < 0){ // Currently no editable row
        return devis;
    }
    if(flattened[row - 1]) {
        var nextRow = flattened[row - 1];
        return editTree(editAllRow(devis, {editing: false}), nextRow, {editing : true} );
    }
    return mapped;
}

// Finds an item in the tree by its built index (prefix + number), mutating tabSearch when modifying this item.
const findItem = (tabSearch, idx) => {
    var foundIdx = _.findIndex(tabSearch, x => x.number == idx);
    // Item found, returning it
    if(foundIdx != -1) {
        return tabSearch[foundIdx];
    }
    // We try to find in subChildren
    else {
        if(idx.indexOf('.') < 0 ){
            return; // No more indent level, so not found here at this indent level
        }
        var newIdx = idx.substring(0, idx.indexOf('.'));
        var rest = idx.substring(idx.indexOf('.') + 1);
        var childrenArray = _.findIndex(tabSearch, x => x.number == newIdx);
        if(childrenArray < 0) { // No occurence found of subIndex
            return;
        }
        // Recursively editing in children
        return findItem(tabSearch[childrenArray].children || [], rest);
    }
}

//************************************************************//
//                            UTILS                           //
//************************************************************//
/**
 * Flattening tab using row children recursively
 * @param {array} tree Devis tree to flatten.
 * @returns The flat array corresponding to the tree view displayed in the browser page.
 */
const flatten = (tree) => {
    var output = [];
    for(var i = 0; i < tree.length; i++) {
        output.push(tree[i]);
        var flatChildren = flatten(tree[i].children || []);
        output = output.concat(flatChildren);
    }
    return output;
}

/**
 * Map all prefixes in the tree. 
 * Rebuilds prefix recursively from parent numbers to last node depth
 */
const mapPrefixes = (devis, prefix) => {
    var copy = _.cloneDeep(devis);
    for(var i = 0; i < copy.length; i++) {
        copy[i].prefix = prefix || '';
        if(copy[i].children) {
            copy[i].children = mapPrefixes(copy[i].children, copy[i].prefix + copy[i].number + '.');
        }
    }
    return copy;
}

//************************************************************//
//                       UPDATE TREE                          //
//************************************************************//
/**
 * Editing a specific row in the tree, without mutating the tree passed in parameter (clone deep)
 */
const editTree = (devis, row, propsToEdit) => {
    var tabSearch = _.cloneDeep(devis || []);
    var idx = (row.prefix || '') + (row.number || '');
    editItem(tabSearch, idx, propsToEdit);
    return tabSearch;
}

/**
 * Apply a transformation on every node of the tree.
 * @param {array} tab Devis Tree
 * @param {Object} propsToEdit Transformation to apply to item (applied with spread operator on each tree node)
 */
const editAllRow = (tab, propsToEdit) => {
    return _.map(tab, (row) => {return {...row, ...propsToEdit, children: editAllRow(row.children, propsToEdit)}});
}

// Edits an item in the tree (mutating tabSearch)
const editItem = (tabSearch, idx, propsToEdit) => {
    var foundIdx = _.findIndex(tabSearch, x => x.number == idx);
    // Item found, mutating tab
    if(foundIdx != -1) {
        tabSearch[foundIdx] = {
            ...tabSearch[foundIdx],
            ...propsToEdit
        }
    }
    // We try to find in subChildren
    else {
        if(idx.indexOf('.') < 0 ){
            return; // No more indent level, so not found here at this indent level
        }
        var newIdx = idx.substring(0, idx.indexOf('.'));
        var rest = idx.substring(idx.indexOf('.') + 1);
        var childrenArray = _.findIndex(tabSearch, x => x.number == newIdx);
        if(childrenArray < 0) { // No occurence found of subIndex
            return;
        }
        // Recursively editing in children
        editItem(tabSearch[childrenArray].children || [], rest, propsToEdit);
    }
}


/**
 * Processing the move of one row up in the tab.
 * Editing the tree accordingly, re-ordering children nodes & re-writing indexes.
 */
const moveUp = (tab, row) => {
    var tabSearch = _.cloneDeep(mapPrefixes(tab) || [])
    // We're not the first child (not gonna swap with parent, only with same level nodes)
    if(row.number && row.number > 1) {
        // We should retrieve parent row with the prefix - '.'
        var prefix = (row.prefix || "")
        var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
        var parentRow = findItem(tabSearch, parentIdx);
        // If previous child has also children
        if((parentRow && parentRow.children[row.number -2].children && parentRow.children[row.number -2].children.length > 0)
            || (!parentRow) && tabSearch[row.number - 2].children && tabSearch[row.number - 2].children.length > 0) {
            // We're not at the same level anymore, we're gonna become previous child's last child, and we remove ourself from our current parent (bye bye !)
            var tabSup = parentRow ? parentRow.children : tabSearch;
            var newNumber = tabSup[row.number -2].children.length + 1;
            var newItem = tabSup[row.number -1];
            newItem.number = newNumber;
            newItem.prefix = newItem.prefix.substring(0, newItem.prefix.lastIndexOf("."));
            tabSup[row.number -2].children.push(newItem);
            for(var i = row.number; i < tabSup.length ; i++) {
                tabSup[i].number --;
            }
            tabSup.splice(row.number -1, 1);
        } else { 
            // We handle both cases : TOP level row (using tabSearch) or deep down row (parentRow)
            var parentTab = parentRow ? parentRow.children : tabSearch;
            var tmp = parentTab[row.number - 1]; // current row is stored
            parentTab[row.number - 1 ] = parentTab[(row.number - 2)]; // previous row is replacing current
            parentTab[(row.number - 2)] = tmp; // current replacing previous
            parentTab[row.number - 1].number += 1;
            parentTab[(row.number - 2)].number -= 1;
            
        }
    } else {
        // Last case : we're first child of our parent, we should become the previous node before our parent (in our parent's parent children)
        // We should retrieve parent row with the prefix - '.'
        var prefix = (row.prefix || "")
        var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
        var parentRow = findItem(tabSearch, parentIdx);
        if(!parentRow){
            return tabSearch;
        }
        var outRow = parentRow.children.shift();
        for(var x = 0 ; x < parentRow.children.length; x++){
            parentRow.children[x].number --;
        }
        var prefix = (row.prefix || "")
        var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
        var grdParentIdx = parentIdx.lastIndexOf('.') > - 1 ? parentIdx.substring(0, parentIdx.lastIndexOf('.')) : '';
        var gParent = findItem(tabSearch, grdParentIdx);
        var tabSup = gParent ? gParent.children : tabSearch;
        outRow.number = parentRow.number;
        outRow.prefix = parentRow.prefix;
        tabSup.splice(parentRow.number -1, 0, outRow);
        for(var i = parentRow.number; i < tabSup.length; i++){
            tabSup[i].number ++;
        }
    }
    return tabSearch;
}
/**
 *  Processing the move of one row down in the tab.
 *  Editing the tree accordingly, re-ordering children nodes & re-writing indexes.
 */
const moveDown = (tab, row) => {
    var tabSearch = _.cloneDeep(tab || [])
    // We should retrieve parent row with the prefix - '.'
    var prefix = (row.prefix || "")
    var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
    var parentRow = findItem(tabSearch, parentIdx);
    // We're not the last child (not gonna swap with next parent, only with same level nodes)
    if(parentRow && parentRow.children.length > row.number || !parentRow && tabSearch.length > row.number) {
        var tabSup = parentRow ?  parentRow.children : tabSearch;
        if(tabSup[row.number].children && tabSup[row.number].children.length > 0) { // Next row has children, we're gonna be one of them
            for(var i = row.number; i < tabSup.length; i++) {
                tabSup[i].number --;
            }
            var rowCopy = _.clone(row);
            rowCopy.number = 1;
            rowCopy.prefix = tabSup[row.number].children[0].prefix;
            tabSup[row.number].children.unshift(rowCopy);
            for(var i = 1; i < tabSup[row.number].children.length; i++ ){
                tabSup[row.number].children[i].number ++;
            }
            tabSup.splice(row.number -1 ,1);
        } else {// Simply swapping 
            var tmp = tabSup[row.number - 1]; // current row is stored
            tabSup[row.number - 1 ] = tabSup[(row.number)]; // next row is replacing current 
            tabSup[row.number] = tmp; // current replacing next
            tabSup[row.number - 1].number -= 1;
            tabSup[(row.number)].number += 1;
        } 
    } else if(parentRow){ // We are in parent row, but we are last, becoming brother of our parent 
        // Trying to find our "grandparent"
        var prefix = (row.prefix || "")
        var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
        var grdParentIdx = parentIdx.lastIndexOf('.') > - 1 ? parentIdx.substring(0, parentIdx.lastIndexOf('.')) : '';
        var gParent = findItem(tabSearch, grdParentIdx);
        var tabSup = gParent ? gParent.children : tabSearch;
        var newRow = _.clone(row);
        if(row.childrenRows){
            newRow.children = row.childrenRows;
        }
        newRow.number = parentRow.number + 1 ;
        newRow.prefix = grdParentIdx;
        parentRow.children.splice((row.number -1), 1 );
        tabSup.splice(parentRow.number , 0, newRow);
        for(var i = parentRow.number + 1 ; i < tabSup.length; i++) {
            tabSup[i].number ++;
        }
    } 

    return tabSearch;
}

//************************************************************//
//                  ADDING ITEMS TO THE TREE                  //
//************************************************************//
/**
 * Adding a top category. If a row is currently selected, adds the top category next to the current row's top categoy.
 * If no row is currently selected, we just add a top category at the end of the quotation.
 * @param {Array} devis The tab containing the tree
 */
const addCategory = (devis) => {
    var tabSearch = _.cloneDeep(devis);
    var row = findCurrentEditingRow(devis);
    tabSearch = mapPrefixes(editAllRow(tabSearch, {editing: false}));
    if(!row) {
        tabSearch.push({
            type: "category",
            number: devis.length + 1,
            name:  "Nouvelle catégorie",
            editing: true,
            children: []
        })
        return tabSearch;
    } 
    var rowIdx = ((row.prefix || '') + (row.number || ''));
    var firstSplit = rowIdx.indexOf('.');
    var topLevel =  firstSplit > - 1 ? rowIdx.substring(0, firstSplit) : row.number;
    for(var i = topLevel; i < tabSearch.length; i++) {
        tabSearch[i].number ++;
    }
    tabSearch.splice(topLevel, 0, {
        type: "category",
        number: Number(topLevel) +1,
        name: "Nouvelle catégorie",
        editing: true,
        children : [],
    });
    return tabSearch;
}
/**
 * Adding a category row under the another row, or by default under the current selected category. 
 * If no row is currently selected, adds the subCategory on the last category in the tree.
 * If the current selected row is not of 'category' type, we try to find its closest 'category' parent to add the new subcategory.
 * @param {Array} devis The devis tab containing the devis tree.
 * @param {*} row The row in which we want to add the subcategory. If no row is passed as parameter, we use the current selected category.
 */
const addSubCategory = (devis, row) => {
    var tabSearch = _.cloneDeep(devis);
    var row = row || findCurrentEditingRow(tabSearch);
    if(!row) {
        // If no row is selected, we search for the last category available in the tree, and we add the subcategory to it.
        return addSubCategory(devis, getLastCategory(devis));
    }
    var rowIdx = ((row.prefix || '') + (row.number || ''));
    tabSearch = mapPrefixes(editAllRow(tabSearch, {editing: false}));
    if(row.type != 'category') {
        var prefix = (row.prefix || "")
        var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
        var parentRow = findItem(tabSearch, parentIdx);
        if(!parentRow) { // Can't find a parent, and we're not a category, se we can't do anything here, not adding any subcategory.
            return tabSearch;
        }
        return addSubCategory(devis, parentRow);
    }
    if(!row.children){
        row.children = []
    }
    row.children.push({
        number: row.children.length + 1,
        name: "Nouvelle catégorie",
        type: "category",
        children : [],
        editing: true,
    });
    editItem(tabSearch, rowIdx, {...row, editing: false})
    return tabSearch;
}

/**
 * Adds an empty fresh Material element to the document tree.
 * @param {*} tab Document tree 
 */
const addMaterial = (tab) => {
    return addRowElement(tab, {
        type: "material",
        name: "Nom du matériau ou de la remise ...",
    });
}

/**
 * Adds an empty fresh Workforce element to the document tree.
 * @param {*} tab Document tree 
 */
const addWorkforce = (tab) => {
    return addRowElement(tab, {
        type: "workforce",
        name: "Nom de la main d'oeuvre ...",
    });
}

/**
 * Adds an empty fresh Work element to the document tree.
 * @param {*} tab Document tree 
 */
const addWork = (tab) => {
    return addRowElement(tab, {
        type: "work",
        name: "Nom de l'ouvrage ...",
    });
}

/**
 * Adds an element to the tree, directly under the specified row or currentSelected row children.
 * If no row is selected, adds the element at the end of the tree.
 * @param {Array} tab The document tree
 * @param {*} element Element to add to the tree, can be material, workforce or work type
 * @param {*} [currentRow] - Row in which to add the specified <element>
 */
const addRowElement = (tab, element, currentRow) => {
    var tabSearch = _.cloneDeep(tab);
    var row = currentRow || findCurrentEditingRow(tabSearch);
    tabSearch = mapPrefixes(editAllRow(tabSearch, {editing: false}));
    if(!row) {
        // No row selected, we add the element at the end of the tab
        // To do that we select the last row from the flattened tab and we apply addRowElement with the latter.
        return addRowElement(tab, element, getLastRow(tab));
    }
    if(row.type != 'category') {
        var prefix = (row.prefix || "")
        var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
        var parentRow = findItem(tabSearch, parentIdx);
        if(!parentRow) { // Can't find a parent, and we're not a category, se we can't do anything here, not adding any element
            return tabSearch;
        }
        return addRowElement(tab, element, parentRow);
    }
    if(!row.children){
        row.children = []
    }
    element.number = row.children.length +1;
    element.editing = true;
    row.children.push(element);
    var rowIdx = ((row.prefix || '') + (row.number || ''));
    editItem(tabSearch, rowIdx, {...row, editing: false})
    return tabSearch;
}

//************************************************************//
//                REMOVING ITEM FROM THE TREE                 //
//************************************************************//
const removeRow = (tab, row) => {
    var tabSearch = _.cloneDeep(tab || [])
    // We should retrieve parent row with the prefix - '.'
    var prefix = (row.prefix || "")
    var parentIdx = prefix.substring(0, prefix.lastIndexOf('.'));
    var parentRow = findItem(tabSearch, parentIdx);
    var supTab = parentRow ?  parentRow.children : tabSearch;
    supTab.splice(row.number -1, 1);
    for(var i = row.number - 1; i < supTab.length; i++) {
        supTab[i].number --;
    }
    return tabSearch;
}

export default {
    editTree,
    editAllRow,
    selectNext,
    selectPrevious,
    moveUp,
    moveDown,
    addCategory,
    addSubCategory,
    removeRow,
    addMaterial,
    addWorkforce,
    addWork,
    hasCategory,
}


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/DevisService.js